import axios from 'axios'
import { CHAT_ENDPOINTS } from '../config/chatEndpoints'
import { toCleanBase64 } from '../utils/imageHelpers'

export const createHairSegmentation = async ({
  photoUrl,
  environment,
  isTrial,
  agentId,
}) => {
  const response = await axios.post(CHAT_ENDPOINTS.segmentation, {
    image: toCleanBase64(photoUrl),
    env: environment,
    is_trial: isTrial,
    agent_id: agentId,
  })

  return response.data?.data || response.data
}

export const extractHairAttributes = async (realHairSegmentedRaw) => {
  const response = await axios.post(CHAT_ENDPOINTS.extractVisualOutput, {
    hair_mask: toCleanBase64(realHairSegmentedRaw),
  })

  return response.data?.data || response.data
}